import DetailPoints from "../DetailPoints";
import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointIrcec = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>
      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "Ircec").length > 0 && (
        <>
          <div className="card">
            <div className="category-column">RAAP</div>
            <div className="value-column">
              <TextField
                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRaap}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "RetraiteCompRaap", e);
                }}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
            <div className="value-column">
              <DropDown
                value={context.state["TableauPoints" + ClientConjoint].AnneeFinRaapComp}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "AnneeFinRaapComp", e);
                  props.CalculRetraite();
                }}
                options={[
                  { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                  { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
                ]}
                normal
              />
            </div>
            <div className="value-column">
              <TextField
                value={resultRetraite?.InfosRetraite?.Raap?.General?.PointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Raap?.General?.PointCalcule}
                disabled={true}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            <DetailPoints caisse="Raap" regime="Complementaire" champ="PointCalcule" libelle="RAAP" />
            </div>
          </div>
          <div className="card">
            <div className="category-column">RACD</div>
            <div className="value-column">
              <TextField
                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRacd}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "RetraiteCompRacd", e);
                }}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
            <div className="value-column">
            <DropDown
                value={context.state["TableauPoints" + ClientConjoint].AnneeFinRacdComp}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "AnneeFinRacdComp", e);
                  props.CalculRetraite();
                }}
                options={[
                  { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                  { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
                ]}
                normal
              />
            </div>
            <div className="value-column">
              <TextField
                value={resultRetraite?.InfosRetraite?.Racd?.General?.PointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Racd?.General?.PointCalcule}
                disabled={true}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            <DetailPoints caisse="Racd" regime="Complementaire" champ="PointCalcule" libelle="RACD" />
            </div>
          </div>
          <div className="card">
            <div className="category-column">RACL</div>
            <div className="value-column">
              <TextField
                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRacl}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "RetraiteCompRacl", e);
                }}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            </div>
            <div className="value-column">
                  <DropDown
                value={context.state["TableauPoints" + ClientConjoint].AnneeFinRaclComp}
                onChange={(e) => {
                  context.handlePointRetraite(ClientConjoint, "AnneeFinRaclComp", e);
                  props.CalculRetraite();
                }}
                options={[
                  { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                  { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
                ]}
                normal
              />
            </div>
            <div className="value-column">
              <TextField
                value={resultRetraite?.InfosRetraite?.Racl?.General?.PointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Racl?.General?.PointCalcule}
                disabled={true}
                dataType="ufloat"
                format={{ thousands: " ", precision: 2, decimal: "," }}
                normal
              />
            <DetailPoints caisse="Racl" regime="Complementaire" champ="PointCalcule" libelle="RACL" />
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default PointIrcec;
